var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12411",
    "data-name": "Group 12411",
    transform: "translate(-309.123 -745.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11054",
    "data-name": "Group 11054",
    transform: "translate(309.164 745.893)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_569",
    "data-name": "Ellipse 569",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(-0.042)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44583",
    "data-name": "Path 44583",
    d: "M41.57,25.757H26.165V41.57H15.405V25.757H0V15.813H15.405V0H26.165V15.813H41.57Z",
    transform: "translate(35.678 6.663) rotate(45)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal_close.a2f16ab65d74a704668e33ea903c2807.svg";
export { ForwardRef as ReactComponent };